module.exports = __webpack_public_path__ + "img/team-2.c6850997.png";